exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tag-container{font-size:1.2rem}.tag-container--small{font-size:.9rem}span.tag{color:#fff;padding:1px 6px;margin-left:5px;background-color:#9f9f9f;border-radius:5px;border:2px solid #fff;font-size:inherit;box-shadow:0 0 8px 0 rgba(0,0,0,.4)}span.tag--first{margin-left:0}span.tag--feature{background-color:#cb8710}span.tag--news{background-color:#547f3a}span.tag--interview{background-color:#1b87d0}span.tag--opinion{background-color:#dc3232}span.tag--update{background-color:#00a900}span.tag--video{background-color:#2a2a2a}span.tag--poem{background-color:#5aa1e3}span.tag--photo{background-color:#942dc1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-4855eba5","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/article/tags.vue
// module id = 50
// module chunks = 4 5